import { Droplets, Armchair, Car, Sparkles, PawPrint, Wrench, Lightbulb, ShieldCheck, Disc3, Wind, Sun, Gem } from "lucide-react";

export const ICONS = {
  droplets: Droplets,
  armchair: Armchair,
  car: Car,
  sparkles: Sparkles,
  paw: PawPrint,
  engine: Wrench,
  headlight: Lightbulb,
  shield: ShieldCheck,
  buffer: Disc3,
  wind: Wind,
  sun: Sun,
  gem: Gem,
};

export const iconFor = (key) => ICONS[key] || Sparkles;
